import TEA_LOCALE_EN from 'tea-component/lib/i18n/locale/en_US';

export const LANGUAGE_EN = 'en-US';
export const LANGUAGE_CN = 'zh-CN';

export const LOCALE_EN = {
  ...TEA_LOCALE_EN,
  emptyText: 'No results found',
};
